import { render, staticRenderFns } from "./SoldOutDot.vue?vue&type=template&id=7c518ff3&lang=pug&"
import script from "./SoldOutDot.vue?vue&type=script&lang=js&"
export * from "./SoldOutDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports